/**
 * Pure semantic-version "has it changed?" check — the heart of the
 * cache-busting mechanism. CacheBuster compares the running bundle version
 * (global.appVersion) against the latest deployed version (Remote Config via
 * /fbversion, or public/meta.json as a fallback); any difference marks the
 * client stale and triggers a cache-clear + reload / the "Update My Backoffice"
 * prompt.
 *
 * Extracted from the versioning store so the exact production logic can be
 * exercised by scripts/version/semver-check.js with no drift. Authored as
 * CommonJS so a plain `node` script can require it directly, while the store
 * imports it via ES-module interop.
 *
 * Behaviour note: inputs are expected to be version strings. Non-string input
 * (undefined / null) throws — matching the original in-store implementation,
 * which relied on callers guarding first (see CacheBuster's runningVersion
 * check).
 */
function semverHasChanged(versionA, versionB) {
  const versionsA = versionA
      .split(/\.|-/g)
      .map(x => parseInt(x))
      .join('-'),
    versionsB = versionB
      .split(/\.|-/g)
      .map(x => parseInt(x))
      .join('-')

  return !!(versionsA !== versionsB)
}

module.exports = { semverHasChanged }
